<template>
  <div class="ViewPromo -methaneservice" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  Компания ООО «МЕТАН-СЕРВИС» опытный и надежный профессионал в
                  сфере топливного бизнеса. Наша компания специализируется на
                  поставках нефтепродуктов, оказании транспортных услуг и
                  сервисном обслуживании АЗС. Успешная работа компании
                  базируется на прямых договорах с производителями, достаточном
                  финансировании, профессиональном коллективе и собственном
                  автопарке бензовозов.
                </p>

                <p>
                  За время развития нашей Компании мы значительно расширили
                  географию поставок топлива, модернизировали автопарк и
                  увеличили количество довольных клиентов.
                </p>
                <h4>Предлагаем услуги:</h4>
                <ul>
                  <li>продажа нефтепродуктов оптом;</li>

                  <li>транспортные услуги по перевозке нефтепродуктов;</li>

                  <li>
                    производство и ввод в эксплуатацию топливозаправочных
                    пунктов, контейнерных АЗС, топливных модулей и резервуаров с
                    наземным или подземным размещением;
                  </li>

                  <li>
                    сервисное техническое обслуживание и ремонт АЗС, комплексные
                    услуги по автоматизации заправочных станций;
                  </li>

                  <li>
                    профессиональная зачистка и ремонт резервуаров для хранения
                    нефтепродуктов на заправочных станциях, профильных
                    предприятиях и нефтяных базах.
                  </li>
                </ul>
                <p>
                  Принципы работы нашей компании - ответственность за качество
                  нефтепродуктов и профессионализм сервисного обслуживания!
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:88003014744"
                          class="ViewPromo__advantage-contact-link"
                          >8 800 301 47 44</a
                        ></strong
                      >
                    </p>
                    <p>
                      Адрес электронной почты:<br />
                      <strong
                        ><a
                          href="mailto:info@methaneservice.com"
                          class="ViewPromo__advantage-contact-link"
                          >info@methaneservice.com</a
                        ></strong
                      >
                    </p>
                  </div>
                </li>
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базисы поставок</h4>
                    <p>cклад продукции NESTRO</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «МЕТАН-СЕРВИС»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 314,
    productId: 1410,
    name: 'ООО «МЕТАН-СЕРВИС»',
    inn: '7719494030 ',
  }),
};
</script>

<style lang="scss">
.-methaneservice .ViewPromo__logo-img {
  height: rem(20);
}
</style>
